import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-semantika',
  templateUrl: './semantika.component.html',
  styleUrls: ['./semantika.component.css'],
})
export class SemantikaComponent {
  url: string = 'socialContentRequests';
  data: Array<any> = [];
  searchText = '';
  filteredData: Array<any> = [];
  searchSuggestions: string[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 50;

  modalTitle: string = '';
  modalContent: string | null = null;

  // Filters
  filters = {
    status: '',
    purpose: '',
    vertical: '',
    requested_by_type: '',
    platform: 'instagram',
  };

  platforms = [
    { value: 'instagram', label: 'Instagram', icon: 'fab fa-instagram', class: 'ig' },
    { value: 'facebook', label: 'Facebook', icon: 'fab fa-facebook-f', class: 'fb' },
    { value: 'youtube', label: 'YouTube', icon: 'fab fa-youtube', class: 'yt' },
    { value: 'tiktok', label: 'TikTok', icon: 'fab fa-tiktok', class: 'tt' },
  ];

  get selectedPlatformInfo() {
    return this.platforms.find(p => p.value === this.filters.platform) || this.platforms[0];
  }

  loading: boolean = true;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  surfacesReviewedData = [
    {
      id: 1,
      surfaceName: 'Feed Posts',
      surfaceIcon: 'fas fa-image text-primary me-2 bg-light p-1 rounded',
      surfaceIconStyle: '',
      description: 'Organic posts in the main feed',
      outcomeText: 'Conclusion Available',
      outcomeIcon: 'far fa-check-circle text-success me-1',
      outcomeClass: '',
      evidenceLevel: 'High',
      evidenceClass: '',
      evidenceDots: ['text-success', 'text-success', 'text-success'],
      notes: 'Sufficient and consistent evidence',
      lastRow: false
    },
    {
      id: 2,
      surfaceName: 'Reels',
      surfaceIcon: 'fas fa-mobile-alt me-2',
      surfaceIconStyle: 'color: #6f42c1',
      description: 'Short-form vertical videos',
      outcomeText: 'Conclusion Available',
      outcomeIcon: 'far fa-check-circle text-success me-1',
      outcomeClass: '',
      evidenceLevel: 'High',
      evidenceClass: '',
      evidenceDots: ['text-success', 'text-success', 'text-success'],
      notes: 'Sufficient and consistent evidence',
      lastRow: false
    },
    {
      id: 3,
      surfaceName: 'Stories',
      surfaceIcon: 'far fa-circle text-danger me-2',
      surfaceIconStyle: '',
      description: '24-hour ephemeral content',
      outcomeText: 'Insufficient Evidence',
      outcomeIcon: 'fas fa-pause-circle text-warning me-1',
      outcomeClass: '',
      evidenceLevel: 'Low',
      evidenceClass: '',
      evidenceDots: ['text-warning', 'text-warning', 'text-light'],
      notes: 'Limited data during period',
      lastRow: false
    },
    {
      id: 4,
      surfaceName: 'Carousels',
      surfaceIcon: 'far fa-images text-info me-2',
      surfaceIconStyle: '',
      description: 'Multi-image/video posts',
      outcomeText: 'No Material Finding',
      outcomeIcon: 'fas fa-minus-circle text-primary me-1',
      outcomeClass: '',
      evidenceLevel: 'Medium',
      evidenceClass: '',
      evidenceDots: ['text-primary', 'text-light', 'text-light'],
      notes: 'No significant changes observed',
      lastRow: false
    },
    {
      id: 5,
      surfaceName: 'Live',
      surfaceIcon: 'fas fa-rss text-danger me-2',
      surfaceIconStyle: '',
      description: 'Instagram Live sessions',
      outcomeText: 'No Activity Observed',
      outcomeIcon: 'fas fa-minus-circle text-secondary me-1',
      outcomeClass: 'text-muted',
      evidenceLevel: 'N/A',
      evidenceClass: 'text-muted',
      evidenceDots: ['text-muted', 'text-muted', 'text-muted'],
      notes: 'No live sessions detected',
      lastRow: true
    }
  ];

  competitorsData = [
    {
      id: 1,
      name: 'Court Express NYC',
      city: 'New York',
      website: 'courtexpressnyc.com',
      websiteUrl: '#',
      categories: 'Legal Courier, Court Filings, Litigation Support',
      surfaces: 'Feed Posts, Reels, Stories, Carousels',
      lastRow: false
    },
    {
      id: 2,
      name: 'Legal Couriers Miami',
      city: 'Miami',
      website: 'legalcouriersmiami.com',
      websiteUrl: '#',
      categories: 'Legal Courier, Process Serving, Same-Day Courier',
      surfaces: 'Feed Posts, Reels, Stories',
      lastRow: false
    },
    {
      id: 3,
      name: 'Swift Legal Delivery',
      city: 'London',
      website: 'swiftlegaldelivery.co.uk',
      websiteUrl: '#',
      categories: 'Court Filings, Legal Courier, Litigation Support',
      surfaces: 'Feed Posts, Reels, Stories, Carousels',
      lastRow: false
    },
    {
      id: 4,
      name: 'LA Legal Runners',
      city: 'Los Angeles',
      website: 'lalegalrunners.com',
      websiteUrl: '#',
      categories: 'Legal Courier, Same-Day Courier, Process Serving',
      surfaces: 'Feed Posts, Stories, Carousels',
      lastRow: false
    },
    {
      id: 5,
      name: 'Prime Same-Day Courier',
      city: 'Chicago',
      website: 'primesamedaycourier.com',
      websiteUrl: '#',
      categories: 'Same-Day Courier, Court Filings, Legal Support',
      surfaces: 'Feed Posts, Reels, Stories',
      lastRow: true
    }
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.loading = true;
    let queryParams = `?page=${this.currentPage}&limit=${this.itemsPerPage}&search=${this.searchText}`;

    if (this.filters.status) queryParams += `&status=${this.filters.status}`;
    if (this.filters.purpose) queryParams += `&purpose=${this.filters.purpose}`;
    if (this.filters.vertical)
      queryParams += `&vertical=${this.filters.vertical}`;
    if (this.filters.requested_by_type)
      queryParams += `&requested_by_type=${this.filters.requested_by_type}`;
    if (this.filters.platform)
      queryParams += `&platform=${this.filters.platform}`;

    this.dataService
      .getData(`${this.url}${queryParams}`)
      .subscribe((response) => {
        if (response && response.data) {
          this.data = response.data;
          this.filteredData = [...this.data];
          this.updateSuggestions();
        }
        this.loading = false;
      });
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.getData();
  }

  resetFilters(): void {
    this.filters = {
      status: '',
      purpose: '',
      vertical: '',
      requested_by_type: '',
      platform: 'instagram',
    };
    this.applyFilters();
  }

  updateItemStatus(id: string, status: string): void {
    this.dataService
      .putData(`${this.url}/${id}/status`, { status })
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  generateAssets(id: string): void {
    if (!confirm('¿Desea generar los assets para este requerimiento?')) return;

    this.dataService
      .postData(`${this.url}/${id}/generate-assets`, {})
      .subscribe((response) => {
        console.log('response', response);
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  filter() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.request_id && item.request_id.toLowerCase().includes(texto)) ||
          (item.notes && item.notes.toLowerCase().includes(texto))
        );
      });
    }
  }

  updateSuggestions() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.request_id) sugerenciasSet.add(item.request_id);
    });
    this.searchSuggestions = Array.from(sugerenciasSet).filter(Boolean);
  }

  showModal(title: string, content: string) {
    this.modalTitle = title;
    this.modalContent = content;
  }

  closeModal() {
    this.modalContent = null;
  }
}
